<template>
  <div
    id="app"
    class="app container"
  >
    <navbar />
    <div class="row">
      <tree
        :hooks="hooks"
        class="col-3"
      />
      <div class="col p-2">
        <h1>{{ hook.endpoint }}</h1>
        <h2>{{ hook.name }}</h2>
        <p v-html="hook.description" />
        <params-template :params="[hook.endpoint, hook.schema, saved_auth_params]" />
        <h3>Параметры</h3>
        <params-table :params="hook.schema" />
        <template v-if="hook.source_code !== null">
          <h4>Исходный код</h4>
          <pre>{{ hook.source_code }}</pre>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '../../components/Navbar.vue'
import Tree from '../../components/Tree.vue'
import ParamsTable from '../../components/params/ParamsTable.vue'
import ParamsTemplate from '../../components/params/ParamsTemplate.vue'


export default {
  name: 'Method',
  components: {
    Navbar,
    Tree,
    ParamsTable,
    ParamsTemplate,
  },
  props: {
    hook: { type: Object, required: true },
    hooks: { type: Array, required: true },
    saved_auth_params: { type: Object, required: true },
  },
}
</script>
